import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgDoubleFileOutline = function SvgDoubleFileOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4.75C7 3.23122 8.23122 2 9.75 2H15.25C15.4489 2 15.6397 2.07902 15.7803 2.21967L20.7803 7.21967C20.921 7.36032 21 7.55109 21 7.75V16.25C21 17.7688 19.7688 19 18.25 19H18V19.25C18 20.7688 16.7688 22 15.25 22H6.75C5.23122 22 4 20.7688 4 19.25V7.75C4 6.23122 5.23122 5 6.75 5H7V4.75ZM7 6.5H6.75C6.05964 6.5 5.5 7.05964 5.5 7.75V19.25C5.5 19.9404 6.05964 20.5 6.75 20.5H15.25C15.9404 20.5 16.5 19.9404 16.5 19.25V19H9.75C8.23122 19 7 17.7688 7 16.25V6.5ZM9.75 17.5C9.05964 17.5 8.5 16.9404 8.5 16.25V4.75C8.5 4.05964 9.05964 3.5 9.75 3.5H14.5V5.75C14.5 7.26878 15.7312 8.5 17.25 8.5H19.5V16.25C19.5 16.9404 18.9404 17.5 18.25 17.5H9.75ZM18.4393 7H17.25C16.5596 7 16 6.44036 16 5.75V4.56066L18.4393 7Z"
  })));
};

export { SvgDoubleFileOutline as ReactComponent };
//# sourceMappingURL=double--file-outline.svg.js.map
